(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-core-js', 'd2v-color-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-core-js'), require('d2v-color-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-interpolate-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-interpolate-js'.");
    }
    if (typeof this['d2v-core-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-interpolate-js'. Its dependency 'd2v-core-js' was not found. Please, check whether 'd2v-core-js' is loaded prior to 'd2v-interpolate-js'.");
    }
    if (typeof this['d2v-color-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-interpolate-js'. Its dependency 'd2v-color-js' was not found. Please, check whether 'd2v-color-js' is loaded prior to 'd2v-interpolate-js'.");
    }
    root['d2v-interpolate-js'] = factory(typeof this['d2v-interpolate-js'] === 'undefined' ? {} : this['d2v-interpolate-js'], kotlin, this['d2v-core-js'], this['d2v-color-js']);
  }
}(this, function (_, Kotlin, $module$d2v_core_js, $module$d2v_color_js) {
  'use strict';
  var coerceIn = Kotlin.kotlin.ranges.coerceIn_nig4hr$;
  var numberToInt = Kotlin.numberToInt;
  var math = $module$d2v_core_js.io.data2viz.math;
  var numberToDouble = Kotlin.numberToDouble;
  var get_deg = $module$d2v_core_js.io.data2viz.math.get_deg_rcaex3$;
  var color = $module$d2v_color_js.io.data2viz.color;
  var round = Kotlin.kotlin.math.round_14dthe$;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwCCE = Kotlin.throwCCE;
  var Point = $module$d2v_core_js.io.data2viz.core.Point;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var indexOf = Kotlin.kotlin.collections.indexOf_2ws7j4$;
  var Math_0 = Math;
  function gamma$lambda(closure$y) {
    return function (a, b) {
      return closure$y === 1.0 ? linear(a, b - a) : exponential(a, b, closure$y);
    };
  }
  function gamma(y) {
    if (y === void 0)
      y = 1.0;
    return gamma$lambda(y);
  }
  function linear$lambda(closure$a, closure$b) {
    return function (t) {
      return closure$a + coerceIn(t, 0.0, 1.0) * closure$b;
    };
  }
  function linear(a, b) {
    return linear$lambda(a, b);
  }
  function exponential$lambda(closure$na, closure$nb, closure$ny) {
    return function (t) {
      var $receiver = closure$na + t * closure$nb;
      var x = closure$ny;
      return Math_0.pow($receiver, x);
    };
  }
  function exponential(a, b, y) {
    var ny = 1 / y;
    var na = Math_0.pow(a, y);
    var nb = Math_0.pow(b, y) - na;
    return exponential$lambda(na, nb, ny);
  }
  function interpolateRgb$lambda(closure$r, closure$g, closure$b) {
    return function (percent) {
      return color.colors.rgba_1ugm5o$(closure$r(numberToDouble(percent)), closure$g(numberToDouble(percent)), closure$b(numberToDouble(percent)));
    };
  }
  function interpolateRgb(start, end, gamma_0) {
    if (gamma_0 === void 0)
      gamma_0 = 1.0;
    var interpolator = gamma(gamma_0);
    var r = interpolator(start.r, end.r);
    var g = interpolator(start.g, end.g);
    var b = interpolator(start.b, end.b);
    return interpolateRgb$lambda(r, g, b);
  }
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var scale$linear_instance = null;
  var scale$ordinal_instance = null;
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$interpolate = package$data2viz.interpolate || (package$data2viz.interpolate = {});
  package$interpolate.gamma_tq0o01$ = gamma;
  package$interpolate.interpolateRgb_ch2ih4$ = interpolateRgb;
  return _;
}));

//# sourceMappingURL=d2v-interpolate-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-interpolate-js.js
// module id = 11
// module chunks = 0